import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EsasSocketComponent } from './esas-socket.component';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: 'ws',
    component: EsasSocketComponent,
    canActivate: [AuthGuard],
    data: { animation: 'WebSocketsPage', permission: null },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EsasSocketRoutingModule {}
